import { render, staticRenderFns } from "./JiGou.vue?vue&type=template&id=36a3acb3"
import script from "./JiGou.vue?vue&type=script&lang=js"
export * from "./JiGou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports